export default __webpack_public_path__ + "static/medgas_valve_box_b.71675c1920f324b1d6fde57993ed31c8.svg";